import Vue from 'vue'

export default {
  init () {
    // 价格
    Vue.filter('money', (value) => {
      if (!value) {
        return '¥0.00' // ￥
      } else {
        return '¥' + Math.abs(parseFloat(value)).toFixed(2)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/config-filter.js